import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {MilestoneRowMenu$key} from './__generated__/MilestoneRowMenu.graphql'
import {ActionList, ActionMenu} from '@primer/react'
import {KebabHorizontalIcon} from '@primer/octicons-react'
import styles from './RepositoryMilestone.module.css'

type MilestoneRowMenuProps = {
  milestone: MilestoneRowMenu$key
}

export function MilestoneRowMenu({milestone}: MilestoneRowMenuProps) {
  const data = useFragment(
    graphql`
      fragment MilestoneRowMenu on Milestone {
        id
      }
    `,
    milestone,
  )

  return (
    <ActionMenu>
      <ActionMenu.Button aria-label="Milestone menu" variant="invisible" icon={<KebabHorizontalIcon />} />

      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.Item
            onSelect={() => {
              alert(`Item one clicked ${data.id}`)
            }}
          >
            Edit
          </ActionList.Item>
          <ActionList.Item
            onSelect={() => {
              alert('Item two clicked')
            }}
          >
            Close
          </ActionList.Item>
          <ActionList.Divider />
          <ActionList.Item
            onSelect={() => {
              alert('Item three clicked')
            }}
          >
            <span className={styles.deleteMilestoneButton}>Delete</span>
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ MilestoneRowMenu.displayName ||= 'MilestoneRowMenu' } catch {}